export const RQ_GET_HOSPITAL_REPORT_API = {
  url: 'reports/customer/hospital/<%= divisionId %>',
  method: 'GET',
  auth: true,
};
